import { SearchOutlined } from "@ant-design/icons";
import { Select } from "antd";
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCurrencySelected } from "../../../redux/slices/currency_slice";
import { getOptionsArray } from "../../../utils/helper";

const CurrencySelectBox = ({ IS_ALL }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const selectedCurrency = useSelector(
    (state) => state.currency.currencySelected
  );
  const exchangeRates = useSelector((state) => state.currency.exchangeRates);
  const optionsArray = getOptionsArray(exchangeRates);
  const selectRef = useRef(null);
  const dispatch = useDispatch();

  const handleChange = (value) => {
    dispatch(setCurrencySelected(value));
    if (selectRef.current) {
      selectRef.current.blur(); // Remove focus from the Select component
    }
  };

  const handleDropdownChange = (open) => {
    setIsDropdownOpen(open);
  };

  return (
    <>
      <div
        className="select-currency-div select-currency-div-dashboard"
        style={IS_ALL ? { position: "relative" } : {}}
      >
        <Select
          suffixIcon={
            isDropdownOpen ? (
              <SearchOutlined />
            ) : (
              <img
                src="/assets/images/icons/chevron-down.svg"
                alt=""
                className="img-fluid"
              />
            )
          }
          showSearch
          optionFilterProp="label"
          placeholder="Select Currency"
          value={selectedCurrency}
          onDropdownVisibleChange={handleDropdownChange}
          onChange={handleChange}
          options={optionsArray}
          style={{ fontWeight: "normal !important", zIndex: 999 }}
          ref={selectRef}
        />
      </div>
    </>
  );
};

export default CurrencySelectBox;
